<template>
  <div class="custom-table-scroll-wrapper" >
    <div class="custom-table-wrapper" v-if="playerSessions.length">
      <CustomTable :custom-class="'view-players-table player-sessions-table'">
        <!-- Table Header -->
          <template slot="theader">
              <TableRow>
                <!-- Session started -->
                  <TableCell>
                      <span class="order-link-wrapper" @click="onSortColumnChange('started')">
                        {{ $t('SESSION_HISTORY.table.session')}}
                          <span class="order-by-btn-wrapper">
                              <span class="up-arrow" :class="{'active' : paginationCriteria.sortColumn == 'started' && !order}"></span>
                              <span class="down-arrow" :class="{'active' : paginationCriteria.sortColumn == 'started' && order}" ></span>
                          </span>
                      </span>
                  </TableCell>
                  <!-- Team -->
                  <TableCell >
                    <span class="order-link-wrapper"  @click="onSortColumnChange('team')">
                        {{ $t('SESSION_HISTORY.table.team')}}
                          <span class="order-by-btn-wrapper">
                              <span class="up-arrow" :class="{'active' : paginationCriteria.sortColumn == 'team' && !order}"></span>
                              <span class="down-arrow" :class="{'active' : paginationCriteria.sortColumn == 'team' && order}" ></span>
                          </span>
                      </span>
                  </TableCell>
                  <!-- Duration -->
                  <TableCell>
                    <span id="duration-tooltip" class="order-link-wrapper" @click="onSortColumnChange('duration')">
                      {{ $t('SESSION_HISTORY.table.duration')}}
                        <span class="order-by-btn-wrapper">
                            <span class="up-arrow" :class="{'active' : paginationCriteria.sortColumn == 'duration' && !order}"></span>
                            <span class="down-arrow" :class="{'active' : paginationCriteria.sortColumn == 'duration' && order}" ></span>
                        </span>
                    </span>
                    <b-tooltip target="duration-tooltip" triggers="hover focus">
                      {{ $t('SESSION_HISTORY.table.durationTooltip')}}
                    </b-tooltip>
                  </TableCell>
                  <!-- Time above 80 % Heart Rate -->
                  <TableCell>
                    <span class="order-link-wrapper" @click="onSortColumnChange('timeAbove80PercentHr')">
                        >80%
                          <span class="order-by-btn-wrapper">
                              <span class="up-arrow" :class="{'active' : paginationCriteria.sortColumn == 'timeAbove80PercentHr' && !order}"></span>
                              <span class="down-arrow" :class="{'active' : paginationCriteria.sortColumn == 'timeAbove80PercentHr' && order}" ></span>
                          </span>
                      </span>
                  </TableCell>
                  <!-- Avg Heart Rate BPM -->
                  <TableCell>
                    <span class="order-link-wrapper" @click="onSortColumnChange('avgHeartRate')">
                        {{ $t('SESSION_HISTORY.table.avgBpm')}}(%)
                          <span class="order-by-btn-wrapper">
                              <span class="up-arrow" :class="{'active' : paginationCriteria.sortColumn == 'avgHeartRate' && !order}"></span>
                              <span class="down-arrow" :class="{'active' : paginationCriteria.sortColumn == 'avgHeartRate' && order}" ></span>
                          </span>
                      </span>
                  </TableCell>
                  <!-- Top Heart Rate BPM -->
                  <TableCell>
                    <span class="order-link-wrapper" @click="onSortColumnChange('maxHeartRate')">
                        {{ $t('SESSION_HISTORY.table.topBpm')}}(%)
                          <span class="order-by-btn-wrapper">
                              <span class="up-arrow" :class="{'active' : paginationCriteria.sortColumn == 'maxHeartRate' && !order}"></span>
                              <span class="down-arrow" :class="{'active' : paginationCriteria.sortColumn == 'maxHeartRate' && order}" ></span>
                          </span>
                      </span>
                  </TableCell>
                  <!-- Active Participation -->
                  <TableCell>
                    <span class="order-link-wrapper" @click="onSortColumnChange('activeParticipation')">
                        {{ $t('SESSION_HISTORY.table.ap')}}%
                          <span class="order-by-btn-wrapper">
                              <span class="up-arrow" :class="{'active' : paginationCriteria.sortColumn == 'activeParticipation' && !order}"></span>
                              <span class="down-arrow" :class="{'active' : paginationCriteria.sortColumn == 'activeParticipation' && order}" ></span>
                          </span>
                      </span>
                  </TableCell>
                  <!-- Calories -->
                  <TableCell>
                    <span id="cal-tooltip" class="order-link-wrapper calories" @click="onSortColumnChange('calories')">
                        {{ $t('SESSION_HISTORY.table.calories')}}
                        <img src="@/assets/images/common/info-btn.png" alt="help icon" class="help-icon" id="tooltip-calories">

                        <b-tooltip target="tooltip-calories" triggers="hover">
                          {{ $t('SESSION_HISTORY.table.tooltipCalories')}}
                        </b-tooltip>
                          <span class="order-by-btn-wrapper">
                              <span class="up-arrow" :class="{'active' : paginationCriteria.sortColumn == 'calories' && !order}"></span>
                              <span class="down-arrow" :class="{'active' : paginationCriteria.sortColumn == 'calories' && order}" ></span>
                          </span>
                      </span>
                      <b-tooltip target="cal-tooltip" triggers="hover focus">
                        {{ $t('SESSION_HISTORY.table.calTooltip')}}
                      </b-tooltip>
                  </TableCell>
                  <!-- Workload -->
                  <TableCell>
                    <span id="workload-tooltip" class="order-link-wrapper" @click="onSortColumnChange('workload')">
                      {{ $t('SESSION_HISTORY.table.workload')}}
                        <span class="order-by-btn-wrapper">
                            <span class="up-arrow" :class="{'active' : paginationCriteria.sortColumn == 'workload' && !order}"></span>
                            <span class="down-arrow" :class="{'active' : paginationCriteria.sortColumn == 'workload' && order}" ></span>
                        </span>
                    </span>
                    <b-tooltip target="workload-tooltip" triggers="hover focus">
                        {{ $t('SESSION_HISTORY.table.workloadTooltip')}}
                      </b-tooltip>
                  </TableCell>
                  <!-- Distance -->
                  <TableCell>
                    <span class="order-link-wrapper" @click="onSortColumnChange('distance')">
                      {{ $t('SESSION_HISTORY.table.distance')}}
                        <span class="order-by-btn-wrapper">
                            <span class="up-arrow" :class="{'active' : paginationCriteria.sortColumn == 'distance' && !order}"></span>
                            <span class="down-arrow" :class="{'active' : paginationCriteria.sortColumn == 'distance' && order}" ></span>
                        </span>
                    </span>
                  </TableCell>
                  <!-- High Speed -->
                  <TableCell>
                    <span id="hs-tooltip" class="order-link-wrapper" @click="onSortColumnChange('highSpeed')">
                      {{ $t('SESSION_HISTORY.table.highSpeed')}}
                        <span class="order-by-btn-wrapper">
                            <span class="up-arrow" :class="{'active' : paginationCriteria.sortColumn == 'highSpeed' && !order}"></span>
                            <span class="down-arrow" :class="{'active' : paginationCriteria.sortColumn == 'highSpeed' && order}" ></span>
                        </span>
                    </span>
                    <b-tooltip target="hs-tooltip" triggers="hover focus">
                      {{ $t('SESSION_HISTORY.table.hsTooltip')}}
                    </b-tooltip>
                  </TableCell>
                  <!-- Number of Sprints -->
                  <TableCell>
                    <span id="sprint-tooltip" class="order-link-wrapper text-uppercase" @click="onSortColumnChange('sprintCount')">
                      {{ $t('SESSION_HISTORY.table.numberOfSprints')}}
                      <span class="order-by-btn-wrapper">
                        <span class="up-arrow" :class="{'active' : paginationCriteria.sortColumn == 'sprintCount' && !order}"></span>
                        <span class="down-arrow" :class="{'active' : paginationCriteria.sortColumn == 'sprintCount' && order}" ></span>
                      </span>
                    </span>
                     <b-tooltip target="sprint-tooltip" triggers="hover focus">
                      {{ $t('SESSION_HISTORY.table.numberOfSprintsTooltip')}}
                    </b-tooltip>
                  </TableCell>
              </TableRow>
          </template>
      </CustomTable>
      <!-- Table Body with Metric values -->
      <CustomTable v-for="(data, i) in playerSessions" v-bind:key="i" :custom-class="'view-players-table player-sessions-table'">
          <template slot="tbody">
            <router-link :to="`/calendar/activity/${data.sessionId}`" class="custom-row link" @click.native="logClick" >
            <TableRow>
                <!-- Session Started -->
                <TableCell>
                    <template v-if="data.invalid">
                    {{$t('COMMON.notApplicable')}}
                  </template>
                  <template v-if="data.started === null && !data.invalid">{{$t('COMMON.notApplicable')}}</template>
                  <template v-if="data.started != null && !data.invalid">{{data.started | dateLocale($i18n.locale, shortDateTimeFormat)}}</template>
                </TableCell>
                <!-- End of Session Started -->
                <!-- Team Name -->
                <TableCell>
                  <template v-if="data.invalid">
                    {{$t('COMMON.notApplicable')}}
                  </template>
                  <template v-if="!data.invalid">
                    {{ data.teamName !== null ? data.teamName: $t('COMMON.notApplicable') }}
                  </template>
                </TableCell>
                <!-- End od Team Name -->
                <!-- Duration -->
                <TableCell>
                  <template v-if="data.invalid">
                    {{$t('COMMON.notApplicable')}}
                  </template>
                  <template v-if="data.durationInSeconds === null && !data.invalid">{{$t('COMMON.notApplicable')}}</template>
                  <template v-if="data.durationInSeconds != null && !data.invalid">{{data.durationInSeconds | secondsToMinutes}} min</template>
                </TableCell>
                <!-- End of Duration -->
                <!-- Time above 80% -->
                <TableCell>
                  <template v-if="data.invalid">
                    {{$t('COMMON.notApplicable')}}
                  </template>
                  <template v-if="data.timeAbove80PercentHrSeconds === null && !data.invalid">{{$t('COMMON.notApplicable')}}</template>
                  <template v-if="data.timeAbove80PercentHrSeconds != null && !data.invalid">{{data.timeAbove80PercentHrSeconds | secondsToMinutesSeconds}}</template>
                </TableCell>
                <!-- End of Time above 80% -->
                <!-- Avg Heart Rate -->
                <TableCell>
                  <template v-if="!data.hrDataValid">
                    {{$t('COMMON.notApplicable')}}
                  </template>
                  <template v-if="!data.invalid && data.hrDataValid">
                    {{data.avgHeartRate != null ? data.avgHeartRate : $t('COMMON.notApplicable') }} ({{data.avgHeartRatePercentage != null ? `${data.avgHeartRatePercentage}%` : $t('COMMON.notApplicable') }})
                    <span v-if="data.avgHeartRateDiff != null" class="text-gray">{{data.avgHeartRateDiff >= 0 ? `+${data.avgHeartRateDiff}%` : `${data.avgHeartRateDiff}%`}}</span>
                    <span class="text-gray" v-if="data.avgHeartRateDiff == null">{{$t('COMMON.notApplicable')}}</span>
                  </template>

                </TableCell>
                <!-- End of Avg Heart Rate %-->
                <!-- Top Heart Rate % -->
                <TableCell>
                  <template v-if="!data.hrDataValid">
                    {{$t('COMMON.notApplicable')}}
                  </template>
                  <template v-if="!data.invalid && data.hrDataValid">
                    {{ data.topHeartRate != null ? data.topHeartRate : $t('COMMON.notApplicable') }} ({{data.topHeartRatePercentage != null ? `${data.topHeartRatePercentage}%` : $t('COMMON.notApplicable')}})
                    <span v-if="data.topHeartRateDiff != null" class="text-gray">{{data.topHeartRateDiff >= 0 ? `+${data.topHeartRateDiff}%` : `${data.topHeartRateDiff}%`}}</span>
                    <span class="text-gray" v-if="data.topHeartRateDiff == null">{{$t('COMMON.notApplicable')}}</span>
                  </template>
                </TableCell>
                <!-- End of Top Heart Rate % -->

                <!-- Active Participation -->
                <TableCell>
                  <template v-if="!data.apDataValid">
                    {{$t('COMMON.notApplicable')}}
                  </template>
                  <template v-if="data.apDataValid">
                    {{ data.activeParticipation != null ? `${data.activeParticipation}%` : $t('COMMON.notApplicable') }}
                  </template>
                </TableCell>
                <!-- End of Active Participation -->

                <!-- Calories -->
                <TableCell>
                  <template v-if="data.invalid">
                    {{$t('COMMON.notApplicable')}}
                  </template>
                  <template v-if="data.kiloCalories === null && !data.invalid">{{$t('COMMON.notApplicable')}}</template>
                  <template v-if="data.kiloCalories != null && !data.invalid">{{data.kiloCalories}}</template>
                </TableCell>
                <!-- End of Calories -->

                <!-- Workload -->
                <TableCell>
                  <template v-if="!data.workloadDataValid">
                    {{$t('COMMON.notApplicable')}}
                  </template>
                  <template v-if="data.workload === null && data.workloadDataValid">{{$t('COMMON.notApplicable')}}</template>
                  <template v-if="data.workload != null && data.workloadDataValid">{{Math.round(data.workload)}}</template>
                </TableCell>
                <!-- End of Workload -->

                <!-- Distance -->
                <TableCell>
                  <template v-if="!data.distanceDataValid">
                    {{$t('COMMON.notApplicable')}}
                  </template>
                  <template v-if="data.distance === null && data.distanceDataValid">{{$t('COMMON.notApplicable')}}</template>
                  <template v-if="data.distance != null && data.distanceDataValid">{{data.distance | number}}m</template>
                </TableCell>
                <!-- End of Distance -->

                <!-- High Speed -->
                <TableCell>
                  <template v-if="data.invalid">
                    {{$t('COMMON.notApplicable')}}
                  </template>
                  <template v-if="!data.invalid">
                    {{ data.percentageAtHighSpeed != null ? `${data.percentageAtHighSpeed}%` : $t('COMMON.notApplicable') }}
                  </template>
                </TableCell>
                <!-- End of High Speed -->

                <!-- # of Sprints -->
                <TableCell>
                  <template v-if="data.invalid">
                    {{$t('COMMON.notApplicable')}}
                  </template>
                  <template v-if="!data.invalid">
                    {{ data.sprintCount != null ? data.sprintCount : $t('COMMON.notApplicable') }}
                  </template>
                </TableCell>
                <!-- End of # of Sprints -->
              </TableRow>
            </router-link>
      </template>
      </CustomTable>
    </div>
    <div v-if="playerSessions.length === 0"><p class="text-center">{{ $t('SESSION_HISTORY.noSessions')}}</p></div>
  </div>
</template>

<script>
import { CustomTable, TableRow, TableCell } from '@/components/common/table'
import { SHORT_DATE_TIME_FORMAT } from '@/constants/DateConstants'

export default {
  name: 'SessionHistoryTable',
  props: {
    playerSessions :  Array,
    onSortColumnChange : Function,
    order : Boolean,
    paginationCriteria : Object,
    account : Object
  },

  data () {
    return {
      shortDateTimeFormat: SHORT_DATE_TIME_FORMAT
    }
  },

  methods: {
    logClick() {
      this.$amplitude.logEvent('pwa: click on session history activity')
    }
  },

  components: {
    CustomTable,
    TableRow,
    TableCell
  }
}
</script>

<style lang="scss" scoped>
  .view-players-table {
    min-width: 1050px;
    table-layout: fixed;
    .table-cell {
      padding: 5px 10px;
      &:first-child {
        width: 9%;
      }

      &:nth-child(2) {
        width: 12%;
      }

      &:nth-child(3) {
        width: 7%;
      }

      &:nth-child(4) {
        width: 6%;
      }

      &:nth-child(5) {
        width: 9%;
      }

      &:nth-child(6) {
        width: 9%;
      }

      @for $i from 7 to 12 {
        &:nth-child(#{$i}) {
          width: 8%;
        }
      }

      &:nth-child(8), &:nth-child(12)  {
        width: 7%;
      }

       &:nth-child(9) {
        width: 6%;
      }

      .help-icon {
        width: 15px;
        height: 15px;
        margin-left: 3px;
        margin-top: 2px;
        cursor: default;
      }
      .calories {
        display: inline-flex;
      }
    }
  }
  .link {
    &.custom-row {
      display: table;
      table-layout: fixed;
      width: 100%;
      cursor: pointer;
        &:hover {
          background-color: $shark-gray;
          box-shadow: 0 6px 13px -3px $cod-gray;
        }
    }
  }

  @media (min-width:1500px){
    .view-players-table {
    table-layout: fixed;
      .table-cell {
        &:nth-child(8) {
          width: 8%;
        }
      }
    }
  }
</style>
